export const tabFor = (tabId, isBroker) => (tabId === 4 && isBroker ? 1 : tabId);

export const latestOnly = (request, apply) => {
  let latest = 0;

  return async (...args) => {
    const mine = ++latest;
    const result = await request(...args);

    if (mine === latest && result != null) apply(result);
  };
};

export const pageOrLast = async (fetchPage, page) => {
  const paginator = await fetchPage(page);

  if (!paginator.data.length && paginator.last_page >= 1 && page > paginator.last_page) {
    return fetchPage(paginator.last_page);
  }

  return paginator;
};
